import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { useImpressionCalculationSubHeader } from './hooks/useImpressionCalculationSubHeader';

export const ImpressionCalculationSubHeader: React.FC = () => {
	const {
		data: { text, display },
	} = useImpressionCalculationSubHeader();

	if (!display) return null;

	return (
		<Text variant="body" size="medium" className="text-typography-weak">
			{text}
		</Text>
	);
};
